export const removeLangFromPathname = (pathname: string) => {
  return pathname.replace(/^\/(uk|aus)/, "") || "/";
}
